import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { PhoneFrame } from './components/layout/PhoneFrame';
import { BottomNav } from './components/layout/BottomNav';
import { Home } from './pages/Home';
import { Schools } from './pages/Schools';
import { SchoolDetail } from './pages/SchoolDetail';
import { Compare } from './pages/Compare';
import { Tools } from './pages/Tools';
import { AiMatch } from './pages/AiMatch';
import { Planner } from './pages/Planner';
import { AgencyAnalysis } from './pages/AgencyAnalysis';
import { Community } from './pages/Community';
import { CaseDetail } from './pages/CaseDetail';
import { PublishCase } from './pages/PublishCase';
import { AgencyDetail } from './pages/AgencyDetail';
import { Mine } from './pages/Mine';
import { MyFavorites } from './pages/MyFavorites';
import { MyAppointments } from './pages/MyAppointments';
import { MyReports } from './pages/MyReports';
import { MyOrders } from './pages/MyOrders';
import { Notifications } from './pages/Notifications';
import { More } from './pages/More';
export function App() {
  return <BrowserRouter data-id="element-0">
      <PhoneFrame data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/schools" element={<Schools data-id="element-6" />} data-id="element-5" />
          <Route path="/schools/:id" element={<SchoolDetail data-id="element-8" />} data-id="element-7" />
          <Route path="/compare" element={<Compare data-id="element-10" />} data-id="element-9" />
          <Route path="/tools" element={<Tools data-id="element-12" />} data-id="element-11" />
          <Route path="/ai-match" element={<AiMatch data-id="element-14" />} data-id="element-13" />
          <Route path="/planner" element={<Planner data-id="element-16" />} data-id="element-15" />
          <Route path="/agency-analysis" element={<AgencyAnalysis data-id="element-18" />} data-id="element-17" />
          <Route path="/community" element={<Community data-id="element-20" />} data-id="element-19" />
          <Route path="/community/cases/publish" element={<PublishCase data-id="element-22" />} data-id="element-21" />
          <Route path="/community/cases/:id" element={<CaseDetail data-id="element-24" />} data-id="element-23" />
          <Route path="/community/agencies/:id" element={<AgencyDetail data-id="element-26" />} data-id="element-25" />
          <Route path="/mine" element={<Mine data-id="element-28" />} data-id="element-27" />
          <Route path="/mine/favorites" element={<MyFavorites data-id="element-30" />} data-id="element-29" />
          <Route path="/mine/appointments" element={<MyAppointments data-id="element-32" />} data-id="element-31" />
          <Route path="/mine/reports" element={<MyReports data-id="element-34" />} data-id="element-33" />
          <Route path="/mine/orders" element={<MyOrders data-id="element-36" />} data-id="element-35" />
          <Route path="/mine/notifications" element={<Notifications data-id="element-38" />} data-id="element-37" />
          <Route path="/more" element={<More data-id="element-40" />} data-id="element-39" />

          {/* Legacy redirects */}
          <Route path="/offer" element={<Navigate to="/ai-match" replace data-id="element-42" />} data-id="element-41" />
          <Route path="/tools/ai-match" element={<Navigate to="/ai-match" replace data-id="element-44" />} data-id="element-43" />
          <Route path="/tools/planner" element={<Navigate to="/planner" replace data-id="element-46" />} data-id="element-45" />
          <Route path="/tools/agency-analysis" element={<Navigate to="/agency-analysis" replace data-id="element-48" />} data-id="element-47" />
          <Route path="/services" element={<Navigate to="/" replace data-id="element-50" />} data-id="element-49" />
          <Route path="/about" element={<Navigate to="/mine" replace data-id="element-52" />} data-id="element-51" />
        </Routes>
        <BottomNav data-id="element-53" />
        <Toaster position="top-center" richColors data-id="element-54" />
      </PhoneFrame>
    </BrowserRouter>;
}